import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { StoredSecret, ENVIRONMENT, Environment } from '@netfoundry-ui/shared/model';
import { Observable } from 'rxjs';
import { HTTP_CLIENT } from '@netfoundry-ui/shared/services';
import {
    GetOption,
    HateoasResourceOperation,
    PagedGetOption,
    HttpMethod,
    PagedResourceCollection,
} from '@lagoshny/ngx-hateoas-client';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class StoredSecretService extends HateoasResourceOperation<StoredSecret> {
    static defaultPaginationSize = 500;
    static defaultHttpAccept = {
        headers: { accept: 'application/hal+json' },
        pageParams: {
            page: 0,
            size: 2000,
        },
    };
    lastPageCount = 0;
    lastTotalCount = 0;
    apiUrl: string;

    constructor(@Inject(HTTP_CLIENT) private http: HttpClient, @Inject(ENVIRONMENT) private environment: Environment) {
        super(StoredSecret);
        this.apiUrl = environment.v3Enabled ? environment.v3apiUrl : environment.v2apiUrl;
    }

    async getStoredSecretPage(options?: PagedGetOption, includeProperties?: string): Promise<StoredSecret[]> {
        let params = { ...StoredSecretService.defaultHttpAccept, ...options };
        if (includeProperties) {
            params = { ...params, headers: { accept: `application/hal+json;includeProperties=${includeProperties}` } };
        }
        return super
            .getPage(params)
            .pipe(
                tap((val) => {
                    this.lastPageCount = val.totalPages;
                    this.lastTotalCount = val.totalElements;
                })
            )
            .toPromise()
            .then((storedSecrets) => (storedSecrets ? storedSecrets.resources : ([] as StoredSecret[])));
    }


    public getJson(ip: string): Observable<string> {
        const options: any = {};
        const url = `${this.apiUrl}stored-secrets/${ip}`;
        return this.http.get(url, options) as Observable<any>;
    }


    public downloadToCsv(networkId: string): Observable<any> {
        const params = new HttpParams().set('networkId', networkId).set('size', this.lastTotalCount);
        const headers = new HttpHeaders().set('Accept', 'text/csv');
        return this.http.get(this.apiUrl + 'stored-secrets', {
            headers: headers,
            params: params,
            responseType: 'text',
        });
    }

    public downloadFileFormat(
        networkId: string,
        format = 'text/csv',
        params: HttpParams = new HttpParams()
    ): Observable<any> {
        params = params.set('networkId', networkId);
        const headers = new HttpHeaders().set('Accept', format);
        return this.http.get(this.apiUrl + 'stored-secrets', {
            headers: headers,
            params: params,
            responseType: 'text',
        });
    }

    public validateCreate(model: any) {
        const headers = new HttpHeaders().set('Accept', 'application/json').set('nf-validate', '');
        return this.http
            .post(this.apiUrl + 'stored-secrets', model, {
                headers: headers,
                responseType: 'json',
            })
            .toPromise();
    }

    validateKey(value: string) {
        const headers = new HttpHeaders().set('Accept', 'application/json').set('nf-validate', '').set('X-Skip-Interceptor', 'true');;
        return this.http
            .post(this.apiUrl + 'stored-secrets', value, {
                headers: headers,
                responseType: 'json',
            })
            .toPromise();
    }

    public getPrivateKey(id: string) {
        const options: any = {};
        const url = `${this.apiUrl}stored-secrets/${id}?includeValue=true`;
        return this.http.get(url, options) as Observable<any>;
    }

    public setPrivateKey(id: string, token: string) {
        const options: any = {};
        const body: any = {}
        const url = `${this.apiUrl}stored-secrets/${id}?token=${token}`;
        return this.http.post(url, body, options) as Observable<any>;
    }

    public getPrivateKeyLink(secretId: string,) {
        const options: any = {};
        const url = `${this.apiUrl}stored-secrets/${secretId}/share`;
        return this.http.post(url, options) as Observable<any>;
    }

    public validateUpdate(secretId: string, model: any) {
        const headers = new HttpHeaders().set('Accept', 'application/json').set('nf-validate', '');
        return this.http
            .put(this.apiUrl + 'stored-secrets/' + secretId, model, {
                headers: headers,
                responseType: 'json',
            })
            .toPromise();
    }

}